import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-dc-csv-download-button',
  templateUrl: './dc-csv-download-button.component.html',
  styleUrls: ['./dc-csv-download-button.component.scss'],
})
export class DcCsvDownloadButtonComponent implements OnInit {
  @Input() data: Array<any> | Observable<any>;

  @Input() fileName: string;

  finishedDownload: boolean = true;

  worker: Worker;

  destroy$ = new Subject();

  constructor() {}

  ngOnInit(): void {}

  downloadCSV(): void {
    this.finishedDownload = false;

    if (!this.worker) {
      this.worker = new Worker(
        new URL('./worker/dc-csv-download-button.worker', import.meta.url)
      );
    }

    if (Array.isArray(this.data)) {
      this.download(this.data);
    } else if (this.data instanceof Observable) {
      this.data
        ?.pipe(first(), takeUntil(this.destroy$))
        .subscribe(this.download.bind(this));
    }
  }

  download(data: any[]) {
    if (typeof Worker !== undefined) {
      this.worker.onmessage = ({ data }) => {
        this.finishedDownload = true;
        const { blob } = data;
        saveAs(
          blob,
          `${this.fileName} ${new Date(Date.now()).toISOString().split('.')[0]}`
        );
      };

      data?.length && this.worker.postMessage(data);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.worker?.terminate();
  }
}
